import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftEditor from "components/SoftEditor";
import { useDispatch } from "react-redux";
import { updateIntegration } from "redux/actions/portal/integrationActionCreator";
import { useIntegrationPermissions } from "hooks/useIntegrationPermissions";

function hasContent(string) {
   const textOnly = string.replace(/<[^>]*>/g, "").trim();
   return textOnly.length > 0;
}

export const Overview = ({ integration }) => {
   const [documentation, setDocumentation] = useState("");
   const [isEditing, setIsEditing] = useState(false);
   const dispatch = useDispatch();
   const { canEdit } = useIntegrationPermissions(integration);

   const handleCancelEdit = () => setIsEditing(false);

   const handleEditDocumentation = () => setIsEditing(true);

   const handleSaveDocumentation = async () => {
      setIsEditing(false);

      dispatch(
         updateIntegration({
            ...integration,
            documentation
         })
      );

      if (!hasContent(documentation)) {
         setDocumentation("");
      }
   };

   useEffect(() => {
      if (!integration) return;

      if (integration?.documentation && hasContent(integration.documentation)) {
         setDocumentation(integration.documentation);
      }
   }, [integration]);

   if (!integration) return <></>;

   return (
      <SoftBox className="overview">
         <SoftBox
            sx={{
               marginBottom: "24px",
               padding: "20px 24px 0 0"
            }}
         >
            {canEdit && (
               <SoftButton
                  sx={{
                     display: "block !important",
                     marginLeft: "auto !important"
                  }}
                  variant="outlined"
                  color="info"
                  onClick={handleEditDocumentation}
               >
                  edit
               </SoftButton>
            )}
         </SoftBox>
         <SoftBox
            className="border-top"
            sx={{
               padding: "32px 12px"
            }}
         >
            {!isEditing && (
               <SoftBox
                  sx={{
                     textAlign: "center",
                     padding: `${documentation ? "" : "48px"} 0 ${documentation ? "" : "64px"}`
                  }}
               >
                  {!documentation && <SoftTypography fontSize="16px">Add documentation</SoftTypography>}
                  <SoftEditor className="documentation preview" theme="bubble" value={documentation} readOnly />
               </SoftBox>
            )}
            {isEditing && (
               <SoftBox>
                  <SoftEditor theme="snow" value={documentation} onChange={(value) => setDocumentation(value)} />
                  <SoftBox
                     sx={{
                        paddingTop: "24px",
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                        columnGap: "18px"
                     }}
                  >
                     <SoftButton
                        sx={{
                           minWidth: "110px"
                        }}
                        variant="outlined"
                        color="info"
                        onClick={handleCancelEdit}
                     >
                        cancel
                     </SoftButton>
                     <SoftButton
                        sx={{
                           minWidth: "110px"
                        }}
                        variant="gradient"
                        size="medium"
                        color="primary"
                        onClick={handleSaveDocumentation}
                        disabled={!documentation}
                     >
                        save
                     </SoftButton>
                  </SoftBox>
               </SoftBox>
            )}
         </SoftBox>
      </SoftBox>
   );
};
